import * as React from "react";
import { Modal, Button } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";

export interface State {}

export interface Props {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onCancel: any;
  onDelete: any;
  message?: string;
  rowData: any;
}

export default class DeleteModal extends React.Component<Props, State> {
  render() {
    const {
      translate,
      title,
      visible,
      onCancel,
      onDelete,
      message,
      rowData
    } = this.props;

    return (
      <div>
        <Modal
          title={title}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("data_grid.modal.actions.cancel")}
            </Button>,
            <Button
              key="submit"
              danger
              onClick={(e) => {
                onDelete(rowData);
                onCancel();
              }}
            >
              {translate("data_grid.modal.actions.delete")}
            </Button>
          ]}
        >
          <span>{message}</span>
        </Modal>
      </div>
    );
  }
}
